import { isEmpty, path } from 'ramda'
import { createSelector } from 'reselect'

const getOrganizations = state => state.dobovoOrganizations

export const selectOrganizationsFetching = state => path(['dobovoOrganizations', 'isFetching'], state)

export const selectOrganizations = createSelector(getOrganizations, organizations => {
    if (!(isEmpty(organizations.entities) || isEmpty(organizations.result))) {
        const items = organizations.entities.organizations
        return organizations.result.map(id => items[id])
    } else {
        return []
    }
})



// WEBPACK FOOTER //
// ./src/selectors/dobovoSelectors/dobovoOrganizations.js